// src/pages/PoliticaPrivacidad.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft, FaFileContract, FaShieldAlt, FaCookieBite, FaStore } from 'react-icons/fa';
import '../styles/LegalPages.css';

const PoliticaPrivacidad = () => {
  return (
    <div className="legal-page">
      <div className="legal-energy-field">
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
        <div className="legal-energy-bolt"></div>
      </div>

      <div className="legal-container">
        <header className="legal-header">
          <h1>🔒 Política de Privacidad</h1>
          <p className="legal-subtitle">
            Cómo protegemos y gestionamos tus datos personales en Reanimeitor
          </p>
        </header>

        <div className="legal-content">
          <div className="legal-owner-info">
            <p><strong>🧑‍💼 Responsable del tratamiento:</strong> Reanimeitor</p>
            <p><strong>📧 Correo electrónico:</strong>info@reanimietor.com</p>
            <p><strong>📍 Ciudad:</strong> Reus, Cataluña, España</p>
          </div>

          <div className="legal-section">
            <h2>🎯 Finalidad del tratamiento</h2>
            <p>
              Los datos personales recogidos a través del formulario de contacto o mediante 
              WhatsApp se utilizan exclusivamente para responder a consultas, enviar 
              información solicitada o gestionar comunicaciones relacionadas con los 
              servicios ofrecidos.
            </p>
          </div>

          <div className="legal-section">
            <h2>📋 Base legal</h2>
            <p>Consentimiento del interesado al enviar el formulario o iniciar contacto por WhatsApp.</p>
          </div>

          <div className="legal-section">
            <h2>📊 Datos recogidos</h2>
            <p>Nombre, correo electrónico, mensaje (y número de teléfono si se contacta por WhatsApp).</p>
          </div>

          <div className="legal-section">
            <h2>⏰ Conservación de los datos</h2>
            <p>
              Los datos se conservarán durante el tiempo necesario para cumplir con la 
              finalidad para la que fueron recogidos o hasta que el usuario solicite su supresión.
            </p>
          </div>

          <div className="legal-section">
            <h2>👥 Destinatarios</h2>
            <p>No se cederán datos a terceros, salvo obligación legal.</p>
          </div>

          <div className="legal-section">
            <h2>🔑 Derechos del usuario</h2>
            <p>
              Los usuarios pueden ejercer sus derechos de acceso, rectificación, supresión, 
              oposición, limitación y portabilidad enviando un correo a 
              <strong>info@reanimietor.com</strong>.
            </p>
          </div>

          <div className="legal-section">
            <h2>🍪 Cookies</h2>
            <p>
              Este sitio puede utilizar cookies técnicas necesarias para su funcionamiento. 
              No se utilizan cookies de terceros ni se recogen datos personales mediante 
              cookies sin consentimiento.
            </p>
          </div>

          <Link to="/" className="legal-back-button">
            <FaArrowLeft /> Volver al Inicio
          </Link>

          <div className="legal-navigation">
            <Link to="/aviso-legal" className="legal-nav-button">
              <FaFileContract /> Aviso Legal
            </Link>
            <Link to="/politica-cookies" className="legal-nav-button">
              <FaCookieBite /> Cookies
            </Link>
            <Link to="/politica-tienda" className="legal-nav-button">
              <FaStore /> Tienda
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;